var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBannerEllipse = function SvgBannerEllipse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1320 451"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1387.5 22c0 74.088 118.62 397.66-97 559-99.41 74.388-465.155 69.999-597 69.999-417.803 0-756.5-87.752-756.5-196 0-108.247 338.697-196 756.5-196 417.8 0 694-345.247 694-237Z"
  })));
};
export default SvgBannerEllipse;